import cx from 'clsx';

import { rem } from '@mantine/core';

import { InputStyleProps } from '../../inputs/types';
import { InputOverrideClassNames } from '../textinput';

import classes from './DateInput.module.css';

export const DefaultDateInputProps = {
  size: 'xl' as const,
  radius: 6
};

export const DateInputOverrideClassNames = (props: InputStyleProps) => {
  const dateInputClasses = InputOverrideClassNames(props);
  return {
    ...dateInputClasses,
    day: classes.day,
    yearsListControl: classes.yearsListControl,
    monthsListControl: classes.monthsListControl,
    weekday: classes.weekday,
    input: cx(dateInputClasses.input, classes.input, {
      [classes.inputWithDays]: props.largeRightSection
    }),
    section: cx(dateInputClasses.section, {
      [classes.section]: props.largeRightSection
    })
  };
};

export const DateInputVarsResolver = (): any => {
  return {
    day: {
      '--day-size': rem(38)
    }
  };
};
